import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import RouteConfig from "./RouteConfig";
function App() {
  return (
    <BrowserRouter>
      <RouteConfig />
    </BrowserRouter>
  );
}

export default App;
